module.exports = __webpack_public_path__ + "img/logo.2dea1b4f.png";